import { render, staticRenderFns } from "./TestMath.vue?vue&type=template&id=75697f70"
import script from "./TestMath.vue?vue&type=script&lang=js"
export * from "./TestMath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports